import { render, staticRenderFns } from "./SpecialistTeamCard.vue?vue&type=template&id=9821ceb6&scoped=true&lang=pug&"
import script from "./SpecialistTeamCard.vue?vue&type=script&lang=js&"
export * from "./SpecialistTeamCard.vue?vue&type=script&lang=js&"
import style0 from "./SpecialistTeamCard.vue?vue&type=style&index=0&id=9821ceb6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9821ceb6",
  null
  
)

export default component.exports